import styled, { css, type DefaultTheme } from 'styled-components';
import {
  sharedButtonStyles,
  getButtonStyle,
  type ButtonStyleProps,
  type ButtonVariant,
} from '#/component-lib/base-components/styled-buttons';

function sharedButtonStyleOverrides(
  props: ButtonStyleProps & { theme: DefaultTheme }
) {
  const underlinedVariants: ButtonVariant[] = ['text'];

  return css`
    ${underlinedVariants.includes(props.variant) &&
    css`
      border: 1px solid transparent;
      @media (any-hover: hover) {
        &:hover {
          background-color: ${getButtonStyle(props, 'backgroundColorHover')};
          border: 1px solid ${getButtonStyle(props, 'borderColorHover')};
        }
      }
    `}
  `;
}

export const StyledButton = styled.button<ButtonStyleProps>`
  ${props => sharedButtonStyles(props)}

  ${sharedButtonStyleOverrides}

  &[type='submit'] {
    // override user agent stylesheet setting on iOS Safari
    font-weight: normal;
  }
`;
